import { render } from "./App.vue?vue&type=template&id=333b7f5f"
const script = {}

import "./App.vue?vue&type=style&index=0&id=333b7f5f&lang=scss"

import exportComponent from "C:\\Jenkins\\workspace\\tformCommunicationViewer_develop\\frontend\\.yarn\\__virtual__\\vue-loader-virtual-12f41bf58f\\5\\YarnPackageCache\\vue-loader-npm-17.0.0-6ebaa2d3c5-0c0a647a4e.zip\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__